// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-ce375d76]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.my-swiper[data-v-ce375d76] {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 250px;\n}\n.my-swiper img[data-v-ce375d76] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
